module.exports = __webpack_public_path__ + "img/ebcTradeSpaceM.96b63c7c.png";